module.exports = __webpack_public_path__ + "static/media/editIcon.53530d4e.svg";